
import { Vue } from "vue-class-component";

export default class CargoConfiguration extends Vue {}
